import React, { Component } from 'react'
import {
    calculateEpochEventMatrices,
    calculateEventMatrices,
    isSecondLevelEventAgreementEnabled
} from '../scoring2/components/functions/calculateEventAgreement'


class EventDataCon extends Component {
    constructor(props) {
        super(props)
        this.state = {

        }
    }
    //拿技師事件

    SumDatareduce = (arr) => {
        return arr.reduce((a, b) => a + b);
    }

    componentDidMount() {
        let msevent = this.props.msevent
        let my_stage = this.props.stage
        let my_modeArr = this.props.modeArr
        let every_thing = []
        const sharedEpochCount = (...series) => Math.min(...series.map(values =>
            values && Number.isInteger(values.length) ? values.length : 0
        ))
        //計算一致性

        // for (let i = 0; i < my_stage.length; i++) {
        //     if (my_modeArr[i] === -1) {
        //         if (my_stage[i] === -1) {
        //             hyp[my_modeArr[i] + 5][my_stage[i] + 5]++;
        //         } else {
        //             hyp[my_modeArr[i] + 5][my_stage[i]]++;
        //         }
        //     } else {
        //         if (my_stage[i] === -1) {
        //             hyp[my_modeArr[i]][my_stage[i] + 5]++;
        //         } else {
        //             hyp[my_modeArr[i]][my_stage[i]]++;
        //         }
        //     }

        // }

        const stageMatrixEpochCount = sharedEpochCount(my_stage, my_modeArr)
        let rwa_matrix = Array(2).fill(0).map(() => new Array(2).fill(0));
        // for (let i = 0; i < stageMatrixEpochCount; i++) {
        //     // The epoch is included if EITHER side scores it as REM (-1) or RWA (-2).
        //     const isRemPeriod = (my_modeArr[i] === -1 || my_modeArr[i] === -2) ||
        //         (my_stage[i] === -1 || my_stage[i] === -2);

        //     if (isRemPeriod) {
        //         // Determine the row index from the consensus reading.
        //         // 0 for Non-RWA, 1 for RWA.
        //         const master_index = (my_modeArr[i] === -2) ? 1 : 0;

        //         // Determine the column index from your reading.
        //         // 0 for Non-RWA, 1 for RWA.
        //         const user_index = (my_stage[i] === -2) ? 1 : 0;

        //         rwa_matrix[master_index][user_index]++;
        //     }
        // }
        for (let i = 0; i < stageMatrixEpochCount; i++) {
            const expertRem = (my_modeArr[i] === -1 || my_modeArr[i] === -2);
            if (!expertRem) continue;                     // 分母：專家 REM 相關 epoch

            const master_index = (my_modeArr[i] === -2) ? 1 : 0;
            const userRem = (my_stage[i] === -1 || my_stage[i] === -2);


            const user_index = userRem
                ? ((my_stage[i] === -2) ? 1 : 0)
                : (1 - master_index);                     // 強制落在非對角線
            rwa_matrix[master_index][user_index]++;
        }


        let rwa_percent_matrix = JSON.parse(JSON.stringify(rwa_matrix)); // 創建副本
        for (let i = 0; i < 2; i++) {
            let sum = this.SumDatareduce(rwa_percent_matrix[i]);
            for (let j = 0; j < 2; j++) {
                if (sum === 0) {
                    rwa_percent_matrix[i][j] = "-";
                } else {
                    rwa_percent_matrix[i][j] = (rwa_percent_matrix[i][j] / sum * 100).toFixed(1);
                }
            }
        }

        let hyp = Array(5).fill(0).map(() => new Array(5).fill(0))
        for (let i = 0; i < stageMatrixEpochCount; i++) {
            // 專家的判讀結果 (黃金標準)
            let master_stage = my_modeArr[i];
            // 您的判讀結果
            let user_stage = my_stage[i];

            // --- 核心邏輯：將 REM (-1) 和 RWA (-2) 都對應到索引 4 ---
            // 處理專家的判讀
            let master_index = (master_stage === -1 || master_stage === -2) ? 4 : master_stage;
            // 處理您的判讀
            let user_index = (user_stage === -1 || user_stage === -2) ? 4 : user_stage;

            // 檢查索引是否有效 
            if (master_index >= 0 && master_index < 5 && user_index >= 0 && user_index < 5) {
                hyp[master_index][user_index]++;
            }
        }
        for (let i = 0; i < 5; i++) {
            let sum = this.SumDatareduce(hyp[i])
            for (let j = 0; j < 5; j++) {
                if (sum === 0) {
                    hyp[i][j] = "-"
                } else {
                    hyp[i][j] = (hyp[i][j] / sum * 100).toFixed(1)
                }
            }
        }
        let re = Array(5).fill(0).map(() => new Array(5).fill(0))
        let Mixed_Apnea_s = this.props.Mixed_Apnea_s
        let Obstructive_Apnea_s = this.props.Obstructive_Apnea_s
        let Central_Apnea_s = this.props.Central_Apnea_s
        let Hypopnea_s = this.props.Hypopnea_s
        const respiratoryMatrixEpochCount = sharedEpochCount(
            my_stage,
            msevent[0],
            msevent[1],
            msevent[2],
            msevent[3],
            Hypopnea_s,
            Obstructive_Apnea_s,
            Central_Apnea_s,
            Mixed_Apnea_s
        )
        let all_re = Array(), all_re_m = Array()
        /* ********* ******
            z_c不知道是啥的縮寫, 但總之看起來是算報告內呼吸事件None的個數
        ********* ****** */
        let z_c = Array(respiratoryMatrixEpochCount).fill(0)
        for (let i = 0; i < respiratoryMatrixEpochCount; i++) {
            if (Hypopnea_s[i] === 0 && Obstructive_Apnea_s[i] === 0 && Central_Apnea_s[i] === 0 && Mixed_Apnea_s[i] === 0) {
                z_c[i] = 1
            }
        }
        let z_c_m = Array(respiratoryMatrixEpochCount).fill(0)
        for (let i = 0; i < respiratoryMatrixEpochCount; i++) {
            if (msevent[0][i] === 0 && msevent[1][i] === 0 && msevent[2][i] === 0 && msevent[3][i] === 0) {
                z_c_m[i] = 1
            }
        }

        all_re.push(z_c)
        all_re.push(Hypopnea_s)
        all_re.push(Obstructive_Apnea_s)
        all_re.push(Central_Apnea_s)
        all_re.push(Mixed_Apnea_s)
        all_re_m.push(z_c_m)
        all_re_m.push(msevent[0])
        all_re_m.push(msevent[1])
        all_re_m.push(msevent[2])
        all_re_m.push(msevent[3])
        // for (let i=0;i<my_stage.length;i++){
        //     for(let j=0;j<5;j++){
        //         for(let h=0;h<5;h++){
        //             if(all_re[j][i]===all_re_m[h][i] && all_re_m[h][i]===1){
        //                 re[h][j]++
        //             }
        //         }
        //     }
        // }

        for (let i = 0; i < respiratoryMatrixEpochCount; i++) {
            let master_re_index = 0; // 預設為 None
            if (msevent[0][i] === 1) { // msevent[0] 是專家 Hypopnea
                master_re_index = 1;
            } else if (msevent[1][i] === 1) { // msevent[1] 是專家 Obstructive Apnea
                master_re_index = 2;
            } else if (msevent[2][i] === 1) { // msevent[2] 是專家 Central Apnea
                master_re_index = 3;
            } else if (msevent[3][i] === 1) { // msevent[3] 是專家 Mixed Apnea
                master_re_index = 4;
            }

            let user_re_index = 0; // 預設為 None
            if (Hypopnea_s[i] === 1) {
                user_re_index = 1;
            } else if (Obstructive_Apnea_s[i] === 1) {
                user_re_index = 2;
            } else if (Central_Apnea_s[i] === 1) {
                user_re_index = 3;
            } else if (Mixed_Apnea_s[i] === 1) {
                user_re_index = 4;
            }

            // 在 confusion matrix 中對應的位置加一
            re[master_re_index][user_re_index]++;
        }

        for (let i = 0; i < 5; i++) {
            let sum = this.SumDatareduce(re[i])
            for (let j = 0; j < 5; j++) {
                if (sum === 0) {
                    re[i][j] = "-"
                } else {
                    re[i][j] = (re[i][j] / sum * 100).toFixed(1);
                }
            }
        }

        const masterArousalRow = Array.isArray(msevent[4]) ? msevent[4] : []
        let ar = Array(2).fill(0).map(() => new Array(2).fill(0))
        let arousal_s = this.props.arousal_s
        const arousalMatrixEpochCount = sharedEpochCount(my_stage, masterArousalRow, arousal_s)
        const invalidArousalMatrixInputs = []
        let invalidArousalMatrixInputCount = 0
        for (let i = 0; i < arousalMatrixEpochCount; i++) {
            const expertValue = masterArousalRow[i]
            const userValue = arousal_s[i]
            if ((expertValue !== 0 && expertValue !== 1) || (userValue !== 0 && userValue !== 1)) {
                invalidArousalMatrixInputCount++
                if (invalidArousalMatrixInputs.length < 20) {
                    invalidArousalMatrixInputs.push({
                        index: i,
                        expertValue,
                        userValue
                    })
                }
                continue
            }
            ar[expertValue][userValue]++;
        }
        for (let i = 0; i < 2; i++) {
            let sum = this.SumDatareduce(ar[i])
            for (let j = 0; j < 2; j++) {
                if (sum === 0) {
                    ar[i][j] = "-"
                } else {
                    ar[i][j] = (ar[i][j] / sum * 100).toFixed(1);
                }
            }
        }

        let sp = Array(2).fill(0).map(() => new Array(2).fill(0))
        let spo2_s = this.props.spo2_s
        const masterSpo2Row = Array.isArray(msevent[5]) ? msevent[5] : []
        const spo2MatrixEpochCount = sharedEpochCount(my_stage, masterSpo2Row, spo2_s)
        for (let i = 0; i < spo2MatrixEpochCount; i++) {
            const expertValue = masterSpo2Row[i]
            const userValue = spo2_s[i]
            sp[expertValue][userValue]++;
        }
        for (let i = 0; i < 2; i++) {
            let sum = this.SumDatareduce(sp[i])
            for (let j = 0; j < 2; j++) {
                if (sum === 0) {
                    sp[i][j] = "-"
                } else {
                    sp[i][j] = (sp[i][j] / sum * 100).toFixed(1);
                }
            }
        }

        // scoring2 receives the expert's exact intervals. Use them for the report matrices
        // so the matrices and the scalar agreement are calculated from the same data.
        const configuredEventMatrices = isSecondLevelEventAgreementEnabled(this.props.psgFileId) &&
            Array.isArray(this.props.masterEvents)
            ? calculateEventMatrices(
                this.props.all_event,
                { events: this.props.masterEvents },
                this.props.totalEpoch
            )
            : calculateEpochEventMatrices({
                hypopnea: Hypopnea_s,
                obstructiveApnea: Obstructive_Apnea_s,
                centralApnea: Central_Apnea_s,
                mixedApnea: Mixed_Apnea_s,
                arousal: arousal_s,
                spo2: spo2_s
            }, msevent, this.props.totalEpoch)
        re = configuredEventMatrices.respiratory
        ar = configuredEventMatrices.arousal
        sp = configuredEventMatrices.spo2

        let lm = Array(2).fill(0).map(() => new Array(3).fill(0))
        let limb_r_s = this.props.limb_r_s
        const masterLimbRow = Array.isArray(msevent[6]) ? msevent[6] : []
        const limbMatrixEpochCount = sharedEpochCount(my_stage, masterLimbRow, limb_r_s)
        if ([stageMatrixEpochCount, respiratoryMatrixEpochCount, arousalMatrixEpochCount, spo2MatrixEpochCount, limbMatrixEpochCount]
            .some(epochCount => epochCount !== my_stage.length)) {
            console.warn('[EventDataCon] matrix calculations use shared valid epoch ranges:', {
                stageLength: my_stage.length,
                totalEpoch: this.props.totalEpoch,
                stageMatrixEpochCount,
                respiratoryMatrixEpochCount,
                arousalMatrixEpochCount,
                spo2MatrixEpochCount,
                limbMatrixEpochCount
            })
        }
        let all_limb = Array(), all_limb_m = Array()
        let z_c_limb = Array(limbMatrixEpochCount).fill(0)
        for (let i = 0; i < limbMatrixEpochCount; i++) {
            if (limb_r_s[i] === 0) {
                z_c_limb[i] = 1
            }
        }
        let z_c_limb_m = Array(limbMatrixEpochCount).fill(0)
        for (let i = 0; i < limbMatrixEpochCount; i++) {
            if (masterLimbRow[i] === 0) {
                z_c_limb_m[i] = 1
            }
        }
        all_limb.push(z_c_limb)
        all_limb.push(limb_r_s)
        all_limb_m.push(z_c_limb_m)
        all_limb_m.push(masterLimbRow)
        for (let i = 0; i < limbMatrixEpochCount; i++) {
            for (let j = 0; j < 2; j++) {
                for (let h = 0; h < 2; h++) {
                    if (all_limb[j][i] === all_limb_m[h][i] && all_limb_m[h][i] === 1) {
                        lm[h][j]++
                    }
                }
            }
        }
        for (let i = 0; i < 2; i++) {
            let sum = this.SumDatareduce(lm[i])
            if (sum != 0) {
                for (let j = 0; j < 2; j++) {
                    lm[i][j] = (lm[i][j] / sum * 100).toFixed(1);
                }
            } else {
                lm[i].fill("-")
            }
        }
        //計算報表
        let reportlist = Array(42).fill(0);
        let sot = 0;
        let wake = 0;
        let n1 = 0;
        let n2 = 0;
        let n3 = 0;
        let rem = 0;
        let rwa = 0;
        for (let i = 0; i < my_stage.length; i++) {
            if (my_stage[i] === 0) wake++;
            else if (my_stage[i] === 1) n1++;
            else if (my_stage[i] === 2) n2++;
            else if (my_stage[i] === 3) n3++;
            else if (my_stage[i] === -1) rem++;
            else if (my_stage[i] === -2) rwa++;
            if ((i + 1) === wake) sot++;
        }

        let OA = 0;
        let CA = 0;
        let MA = 0
        let OH = 0;
        let AHI_rem = 0
        let AHI_nrem = 0
        let ARO = 0
        let MAX_A = 0, MAX_OH = 0
        let total_OA = 0, total_CA = 0, total_MA = 0, total_OH = 0
        let PLMFL = [], PLMTL = [], PLM_REM = 0
        for (const [_, value] of Object.entries(this.props.all_event)) {
            const eventMidpoint = (Number(value.secondFrom) + Number(value.secondTo)) / 2
            const stageIndex = Math.min(my_stage.length - 1, Math.max(0, Math.floor(eventMidpoint / 30)))
            const current_stage = my_stage[stageIndex]
            let isRespiratoryEvent = false
            if (value.type === "Mixed Apnea") {
                isRespiratoryEvent = true
                MA++;
                if (value.secondTo - value.secondFrom > MAX_A) {
                    MAX_A = value.secondTo - value.secondFrom
                }
                total_MA = total_MA + value.secondTo - value.secondFrom
            }
            else if (value.type === "Obstructive Apnea") {
                isRespiratoryEvent = true
                OA++;
                if (value.secondTo - value.secondFrom > MAX_A) {
                    MAX_A = value.secondTo - value.secondFrom
                }
                total_OA = total_OA + value.secondTo - value.secondFrom
            }
            else if (value.type === "Central Apnea") {
                isRespiratoryEvent = true
                CA++;
                if (value.secondTo - value.secondFrom > MAX_A) {
                    MAX_A = value.secondTo - value.secondFrom
                }
                total_CA = total_CA + value.secondTo - value.secondFrom
            }
            else if (value.type === "Obstructive Hypopnea" || value.type === "Central Hypopnea" || value.type === "Mixed Hypopnea" || value.type === "Hypopnea") {
                isRespiratoryEvent = true
                OH++;
                const duration = value.secondTo - value.secondFrom;
                if (duration > MAX_OH) {
                    MAX_OH = value.secondTo - value.secondFrom
                }
                if (duration > 0) {
                    total_OH += duration;
                } else {
                    console.warn("⚠️ 發現異常呼吸事件：", value);
                }
                // total_OH = total_OH + value.secondTo - value.secondFrom
            }
            else if (value.type === "ARO SPONT") {
                ARO++
            }
            else if (value.type === "Limb movement (Right)") {
                PLMFL.push(value.secondFrom)
                PLMTL.push(value.secondTo)
                if (current_stage === -1 || current_stage === -2) {
                    PLM_REM++;
                }
            }
            else if (value.type === "Limb movement (Left)") {
                PLMFL.push(value.secondFrom)
                PLMTL.push(value.secondTo)
                if (current_stage === -1 || current_stage === -2) {
                    PLM_REM++;
                }
            }
            if (isRespiratoryEvent) {
                if (current_stage === -1 || current_stage === -2) {
                    AHI_rem++
                } else if (current_stage === 1 || current_stage === 2 || current_stage === 3) {
                    AHI_nrem++
                }
            }
        }
        let PLMS = [], tmp_PLMS = [], tr = 0
        for (let i = 0; i < PLMTL.length - 1; i++) {
            if ((PLMFL[i + 1] - PLMTL[i] <= 90) && tr === 0) {
                tmp_PLMS.push(PLMTL[i]);
                tmp_PLMS.push(PLMTL[i + 1])
                //console.log(tmp_PLMS.length)
                tr = 1
            } else if ((PLMFL[i + 1] - PLMTL[i] <= 90) && tr === 1) {
                tmp_PLMS.push(PLMTL[i + 1])
                //console.log(tmp_PLMS.length)
            } else if ((PLMFL[i + 1] - PLMTL[i] > 90)) {
                tmp_PLMS = []
                tr = 0
            }
            if (tmp_PLMS.length === 4) {
                for (let j = 0; j < 4; j++) {
                    PLMS.push(tmp_PLMS[j])
                }
            } else if (tmp_PLMS.length > 4) {
                PLMS.push(tmp_PLMS[tmp_PLMS.length - 1])
            }

        }
        let PLMS_REM = 0
        for (let i = 0; i < PLMS.length; i++) {
            const current_stage = my_stage[Math.floor(PLMS[i] / 30)];
            if (current_stage === -1 || current_stage === -2) {
                PLMS_REM++;
            }
        }
        const formatRate = (count, hours) => hours > 0 ? (count / hours).toFixed(1) : "0.0"
        const formatPercent = (count, total) => total > 0 ? (count / total * 100).toFixed(1) : "0.0"
        const totalSleepEpochs = my_stage.length - wake
        const totalSleepHours = totalSleepEpochs / 120
        const remSleepHours = (rem + rwa) / 120
        const nremSleepHours = (n1 + n2 + n3) / 120
        reportlist[0] = formatRate(OA + CA + MA + OH, totalSleepHours); // AHI
        reportlist[1] = formatRate(OA + CA + MA, totalSleepHours); // AI
        reportlist[2] = formatRate(OH, totalSleepHours); // HI
        reportlist[3] = formatRate(OA, totalSleepHours); // OI
        reportlist[4] = formatRate(CA, totalSleepHours); // CI
        reportlist[5] = formatRate(MA, totalSleepHours); // MI
        reportlist[6] = formatRate(AHI_rem, remSleepHours); // AHI(REM)
        reportlist[7] = formatRate(AHI_nrem, nremSleepHours); // AHI(NREM)
        reportlist[8] = (my_stage.length / 2).toFixed(1); // total record time
        reportlist[9] = ((my_stage.length - sot) / 2).toFixed(1); // total sleep period
        reportlist[10] = ((my_stage.length - wake) / 2).toFixed(1); // total sleep time
        reportlist[11] = (wake / 2).toFixed(1); // awake time
        reportlist[12] = formatPercent(n1, totalSleepEpochs); // N1 %
        reportlist[13] = formatPercent(rem + rwa, totalSleepEpochs); // REM %
        reportlist[14] = formatPercent(n2, totalSleepEpochs); // N2 %
        const sleepLatencyEpochs = Number(this.props.psgFileId) === 5 ? Math.max(0, sot - 24) : sot
        reportlist[15] = (sleepLatencyEpochs / 2).toFixed(1); // sleep latency
        reportlist[16] = formatPercent(n3, totalSleepEpochs); // N3 %
        reportlist[17] = formatPercent(totalSleepEpochs, my_stage.length); // efficiency
        reportlist[18] = formatRate(ARO, totalSleepHours); // arousal index
        reportlist[19] = OA; // OA count
        reportlist[20] = (total_OA / 60).toFixed(1); // OA duration
        reportlist[21] = CA; // CA count
        reportlist[22] = (total_CA / 60).toFixed(1); // CA duration
        reportlist[23] = MA; // MA count
        reportlist[24] = (total_MA / 60).toFixed(1); // MA duration
        reportlist[25] = OH; // H count
        reportlist[26] = (total_OH / 60).toFixed(1); // H duration
        reportlist[27] = (MAX_A).toFixed(1); // longest apnea
        reportlist[28] = (MAX_OH).toFixed(1); // longhest hypopnea
        // if(this.props.spo2_deast.length!=0){
        // reportlist[29]=-(this.SumDatareduce(this.props.spo2_deast)/this.props.spo2_deast.length).toFixed(1);
        // }
        if (this.props.spo2_respiratory.length != 0) { // Mean Spo2 with respiratory events
            reportlist[29] = (this.SumDatareduce(this.props.spo2_respiratory) / this.props.spo2_respiratory.length).toFixed(1);
        }
        reportlist[30] = formatRate(this.props.spo2_deast.length, totalSleepHours); // ODI
        reportlist[31] = PLM_REM;
        reportlist[32] = (PLMFL.length - PLM_REM);
        reportlist[33] = (PLMFL.length);
        reportlist[34] = PLMS_REM;
        reportlist[35] = (PLMS.length - PLMS_REM);
        reportlist[36] = (PLMS.length);
        reportlist[37] = formatRate(PLMS_REM, totalSleepHours);
        reportlist[38] = formatRate(PLMS.length - PLMS_REM, totalSleepHours);
        reportlist[39] = formatRate(PLMS.length, totalSleepHours);
        reportlist[40] = formatPercent(rwa, rwa + rem)
        reportlist[41] = this.props.hypoxicBurden === null || this.props.hypoxicBurden === undefined
            ? "-"
            : this.props.hypoxicBurden

        let fa_reportlist = Array(40).fill(0);
        let fa_sot = 0;
        let fa_wake = 0;
        let fa_n1 = 0;
        let fa_n2 = 0;
        let fa_n3 = 0;
        let fa_rem = 0;
        for (let i = 0; i < my_stage.length; i++) {
            if (my_modeArr[i] === 0) fa_wake++;
            else if (my_modeArr[i] === 1) fa_n1++;
            else if (my_modeArr[i] === 2) fa_n2++;
            else if (my_modeArr[i] === 3) fa_n3++;
            else if (my_modeArr[i] === -1 || my_modeArr[i] === -2) fa_rem++;

            if ((i + 1) === fa_wake) fa_sot++;
        }
        fa_reportlist[9] = ((my_stage.length - fa_sot) / 2).toFixed(1);
        fa_reportlist[10] = ((my_stage.length - fa_wake) / 2).toFixed(1);
        fa_reportlist[11] = (fa_wake / 2).toFixed(1);
        const faSleepEpochs = my_stage.length - fa_wake
        fa_reportlist[12] = formatPercent(fa_n1, faSleepEpochs);
        fa_reportlist[13] = formatPercent(fa_rem, faSleepEpochs);
        fa_reportlist[14] = formatPercent(fa_n2, faSleepEpochs);
        fa_reportlist[15] = (fa_sot / 2).toFixed(1);
        fa_reportlist[16] = formatPercent(fa_n3, faSleepEpochs);
        fa_reportlist[17] = formatPercent(faSleepEpochs, my_stage.length);
        /* ********* ******
            下載的時候才計算一致性寫入後端的json檔裡
            所以第一位下載的user就是1/1名
            第二位可能是1/2或2/2
            2022學長指使學姐登入所有使用者號先下載過一遍應該是要讓一致性分數都寫入json檔
        ********* ****** */
        // let all_add_apnea=[],m_all_add_apnea=[]
        // for (let i=0;i<my_stage.length;i++){
        //     if (Obstructive_Apnea_s[i]===1 || Central_Apnea_s[i]===1 || Mixed_Apnea_s[i]===1){
        //         all_add_apnea.push(1)
        //     }else{
        //         all_add_apnea.push(0)
        //     }
        // }
        // for (let i=0;i<my_stage.length;i++){
        //     if (msevent[1][i]===1 || msevent[2][i]===1 || msevent[3][i]===1){
        //         m_all_add_apnea.push(1)
        //     }else{
        //         m_all_add_apnea.push(0)
        //     }
        // }
        // let score_hyp=0,score_re=0,score_ar=0,score_spo2=0,score_lm=0
        // for (let i=0;i<my_stage.length;i++){
        //     if(my_modeArr[i]===my_stage[i]){
        //         score_hyp++;
        //     }
        //     if(all_add_apnea[i]===m_all_add_apnea[i]){
        //         if(msevent[0][i]===Hypopnea_s[i]){
        //             score_re++;
        //         }
        //     }
        //     if(msevent[4][i]===arousal_s[i]){
        //         score_ar++;
        //     }
        //     if(msevent[5][i]===spo2_s[i]){
        //         score_spo2++;
        //     }
        //     if(msevent[6][i]===limb_r_s[i]){
        //         score_lm++;
        //     }
        // }
        // let test_1=0,test_2=0,test_3=0,test_4=0,test_5=0
        // for (let i=0;i<my_stage.length;i++){
        //     if(all_add_apnea[i]==1){
        //         test_1++;
        //     }
        //     if(Hypopnea_s[i]==1){
        //         test_2++;
        //     }
        //     if(arousal_s[i]==1){
        //         test_3++;
        //     }
        //     if(spo2_s[i]==1){
        //         test_4++;
        //     }
        //     if(limb_r_s[i]==1){
        //         test_5++;
        //     }
        // }
        // if(test_1==0 && test_2==0){
        //     score_re=0;
        // }
        // if(test_3==0){
        //     score_ar=0;
        // }
        // if(test_4==0){
        //     score_spo2=0;
        // }
        // if(test_5==0){
        //     score_lm=0;
        // }
        let all_score = [];
        // all_score.push(((score_hyp/my_stage.length)*100).toFixed(1))
        // all_score.push(((score_re/my_stage.length)*100).toFixed(1))
        // all_score.push(((score_ar/my_stage.length)*100).toFixed(1))
        // all_score.push(((score_spo2/my_stage.length)*100).toFixed(1))
        // all_score.push(((score_lm/my_stage.length)*100).toFixed(1))


        every_thing.push(hyp) // 學員與專家 stage confusion matrix
        every_thing.push(re) // 學員與專家 respiration confusion matrix
        every_thing.push(ar) // 學員與專家 arousal confusion matrix
        every_thing.push(sp) // 學員與專家 SpO2 confusion matrix
        every_thing.push(lm) // 學員與專家 PLM confusion matrix

        every_thing.push(reportlist)
        every_thing.push(rwa_percent_matrix)
        every_thing.push(all_score)
        every_thing.push(fa_reportlist)


        if (this.props.eventData.length === 0) {
            this.props.savedata(every_thing);
        }
        if (this.props.wait02 === false) {
            this.props.oknext02(true)
        }
    }
    render() {

        return null;
    }



}
export default EventDataCon
